export class GerarPixDinamico {
    constructor() { }

    public valor: number;
    public numeroPedido: string;
    public cnpjCedente: string;
    public nomeCedente: string;
    public diasExpiracao: number;
    public cedenteGuid: string;
}
